<template>
  <BModal :id="id" :visible="show" scrollable size="xl" body-class="bg-auth-4" @hide="$emit('hide')">
    <template #modal-header>
      <h5 class="mb-3 mt-auto ml-auto mr-auto modal-title">Bulk Discounts</h5>
      <button type="button" class="modal-close" aria-label="Close" @click="$emit('hide')">
        <i class="fa fa-times-thin" style="font-size: 1.5em" />
      </button>
    </template>
    <div class="mx-3">
      <BushelCard v-for="discount in bulkDiscounts" :key="discount.id" class="my-2">
        <h5 class="mb-0">
          <span>{{ `Order ${discount.minimum_quantity} ${unitType(discount, "plural")}` }}</span>
          <span>{{
            ` of ${discount.product_category.name} ${discount.product_type_id ? " - " : ""} ${
              discount.product_type_id ? discount.product_type.name : ""
            } to receive a $${discount.discount / 100} discount per ${unitType(discount, "singular")}`
          }}</span>
        </h5>
      </BushelCard>
    </div>
    <template #modal-footer>
      <BushelBtn variant="secondary" ripple-color="secondary" flat @click="$emit('hide')"> Close </BushelBtn>
    </template>
  </BModal>
</template>

<script>
export default {
  components: {},
  props: {
    show: { type: Boolean, required: true },
    id: { type: String, default: "bulkDiscountsModal" },
    bulkDiscounts: { type: Array, required: true },
  },
  emits: ["hide"],
  data() {
    return {};
  },

  mounted() {},
  methods: {
    unitType(discount, type) {
      if (discount.package_case_type == "Package") {
        if (type == "plural") {
          return discount.product_category.name == "Live Plant" ? "Flats" : "Packages";
        }
        return discount.product_category.name == "Live Plant" ? "Flat" : "Package";
      }
      if (discount.package_case_type == "Case") {
        if (type == "plural") {
          return discount.product_category.name == "Live Plant" ? "Trays" : "Cases";
        }
        return discount.product_category.name == "Live Plant" ? "Tray" : "Case";
      }

      return type == "singular" ? discount.unit_of_measurement.name : `${discount.unit_of_measurement.name}s`;
    },
  },
};
</script>
